import React from 'react';
import styles from "./RoleSelect.module.css";
import "./RoleSelect.scrollbar.css";
import {customStyles, SelectOption} from "../modalStyles";
import {DropdownIndicator} from "../DropdownIndicator";
import {CustomOption} from "../CustomOption/CustomOption";
import {truncateText} from "../../../Utils/text";
import Select, { components } from 'react-select'

interface RoleSelectProps {
    selectedRoles: SelectOption[];
    setSelectedRoles: (roles: SelectOption[]) => void;
    options: SelectOption[];
    className?: string;
    placeholder?: string;
    isSearchable?: boolean;
}

export const RoleSelect: React.FC<RoleSelectProps> = ({
    selectedRoles,
    setSelectedRoles,
    options,
    className,
    placeholder = "Выберите роли",
                                                          isSearchable = false
}) => {
    const Input = (props: any) => {
        // Удаляем inputProps, чтобы не было warning
        const { inputProps, ...rest } = props;
        return (
            <components.Input
                {...rest}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck={false}
            />
        );
    };

    return (
        <Select
            isMulti
            className={className || styles.selectWrapper}
            classNamePrefix="kbrole"
            name="roles"
            options={options}
            isSearchable={isSearchable}
            isClearable={false}
            placeholder={placeholder}
            noOptionsMessage={() => "Нет доступных опций"}
            styles={customStyles}
            components={{
                IndicatorSeparator: () => null,
                DropdownIndicator,
                Option: CustomOption,
                Input
            }}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            blurInputOnSelect={false}
            value={selectedRoles}
            onChange={(newValue) => setSelectedRoles(newValue as SelectOption[])}
            formatOptionLabel={({label, fullLabel}, {context}) => (
                <div title={fullLabel}>
                    {context === 'value' ? truncateText(label) : label}
                </div>
            )}
        />
    );
};